import { useCallback, useMemo, useState } from 'react';
import { User } from 'models/User';
import useCallbackRef from './useCallbackRef';
import { ModalRef } from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import { getIsUserVerified } from 'utils';
import { getIsValidPhone } from 'phoneNumberUtils';

export default function useVerification(currentUser: User) {
  const [enquireListingId, setEnquireListingId] = useState<string>();

  const isUserVerified = useMemo(
    () =>
      getIsUserVerified(
        currentUser?.hasVerifiedEmail,
        currentUser?.hasVerifiedContactNumber,
      ),
    [currentUser],
  );

  const [emailMissingModal, emailMissingModalRef] = useCallbackRef<ModalRef>();
  const [needEmailVerificationModal, needEmailVerificationModalRef] =
    useCallbackRef<ModalRef>();

  const [phoneMissingModal, phoneMissingModalRef] = useCallbackRef<ModalRef>();
  const [phoneVerificationModal, phoneVerificationModalRef] =
    useCallbackRef<ModalRef>();

  const openPhoneVerificationModal = useCallback(() => {
    if (!getIsValidPhone(currentUser?.phone)) {
      phoneMissingModal?.open();
      return;
    }

    if (!currentUser?.hasVerifiedContactNumber) {
      phoneVerificationModal?.open();
    }
  }, [currentUser, phoneMissingModal, phoneVerificationModal]);

  const openVerificationModal = useCallback(
    (shouldCheckPhone = false, listingId) => {
      setEnquireListingId(listingId || undefined);

      if (!currentUser?.email) {
        emailMissingModal?.open();
        return;
      }

      if (!currentUser?.hasVerifiedEmail) {
        needEmailVerificationModal?.open();
        return;
      }

      if (shouldCheckPhone) {
        openPhoneVerificationModal();
      }
    },
    [
      currentUser,
      emailMissingModal,
      needEmailVerificationModal,
      openPhoneVerificationModal,
    ],
  );

  return {
    isUserVerified,
    enquireListingId,
    phoneVerificationModal,
    emailMissingModalRef,
    needEmailVerificationModalRef,
    phoneMissingModalRef,
    phoneVerificationModalRef,
    openVerificationModal,
    openPhoneVerificationModal,
  };
}
